import ConsentManagement from './ConsentManagement'
export default ConsentManagement
